import { useEffect } from "react";
import { Link } from "react-router-dom";

const setMeta = (name, content) => {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  const created = !el;
  if (created) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  const previous = el.getAttribute("content");
  el.setAttribute("content", content);
  return () => (created ? el.remove() : el.setAttribute("content", previous));
};

export default function NotFoundPage() {
  useEffect(() => {
    document.title = "Page introuvable | Jyvis Assurances";
    const undo = [setMeta("robots", "noindex, follow"), setMeta("prerender-status-code", "404")];
    return () => undo.forEach((fn) => fn());
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center bg-white px-5" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <p className="text-7xl font-bold text-[#102692]">404</p>
        <h1 className="mt-4 text-2xl font-bold text-slate-900">Cette page n'existe pas</h1>
        <p className="mt-3 text-slate-600">Le lien est peut-être erroné ou la page a été déplacée.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="rounded-full bg-[#102692] text-white px-6 py-3 font-semibold" data-testid="not-found-home-link">Retour à l'accueil</Link>
          <a href="tel:+33148209827" className="rounded-full border-2 border-[#102692] text-[#102692] px-6 py-3 font-semibold" data-testid="not-found-call-link">01 48 20 98 27</a>
        </div>
      </div>
    </main>
  );
}
